import React from 'react'
import Icon from '../misc/Icons'
import StaticQuestionSlide from '../slides/StaticQuestionSlide'

class FloatingNPControl extends React.Component{	

	render(){	

		const {section,showLiveViewModal,stopLiveView,control}=this.props
		
		return(
			<div className='floatingNPControl'>
				<div className='floatingNPControl-header'>
					{section && 
						<div className='floatingNPControl-header-expandLabel'>							
							Open Now Playing
						</div>
					}

					{section && 
						<button onClick={stopLiveView} className='floatingNPControl-header-closeButton'>							
							<Icon name="close" />
						</button>
					}

				</div>				        

		 		<div className='floatingNPControl-questionPreview' onClick={showLiveViewModal}>		       	


		        {control.snapshot &&
		          <StaticQuestionSlide question={control.snapshot} stage='ask' mode='view' displayWidth={366} />       
		        }
			     
				</div>

			</div>
	      
		)
	}
				
}

export default FloatingNPControl

// {!control.snapshot &&
// 			     	<div className='floatingNPControl-questionPreview-oldAppError'>
// 			     		It looks like you might be using an old version of the mobile app. <br/><br/> Please update your iOS/Android app to 4.0 to get everything working smoothly!
// 			     	</div>
// 			     }   	



// WEBPACK FOOTER //
// ./src/components/liveView/FloatingNPControl.js